import {clientStaffRoutes} from '../utils';

import Flags from '@/views/flags/Flags';

// import store from '@/store';

export default [
   ...clientStaffRoutes({
      name: 'flags-and-issues',
      path: '/flags',
      component: Flags,
      stage: 'flags',
      breadCrumb: [
         {text: 'Dashboard', to: {name: 'Home'}},
         {
            text: '__COMPANYNAME__',
            to: {name: 'company-detail', params: {id: 'FILL'}},
         },
         {text: 'Flags and Issues'},
      ],
   }),
];
